import Vue from 'vue'
import App from '@/App.vue'

require('dotenv').config();

import 'Components'
import '@/registerServiceWorker'
import router from '@/router'
import store from '@/vuex/store';

window.Vue = Vue;

// Boostrap
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBdZcrpWfXStW2Uui8iweJYvwCv18xvrYg',
        libraries: 'places', // This is required if you use the Autocomplete plugin
    }
});

// Moment
import moment from 'moment'

Vue.prototype.moment = moment

//User
import User from "./services/user";
let user = new User(store.getters.user);

// VueAxios
import Axios from 'axios'
let axios = Axios.create({
    baseURL:process.env.VUE_APP_API_URI
});
axios.interceptors.request.use((config) => {
    config.params = config.params || {};
    config.params['key'] = user.apiKey();
    return config;
});
Vue.prototype.$http = axios;
store.$axios = axios;

// Scandit
import * as ScanditSDK from "scandit-sdk";
const licenseKey = "Ad8+hNSBQHr8EvzGyRiLYKc2d4cKDTkQTmLGjY46TuKDLMq1gRtqn5lPQwDcXwH8BSt8NHpiS1/JQIwpuip6CshIpyXGQ65iDiTFxkhstoTbTzodok53zfERsQKnPvd7vQDtRwwiHCCtrD3CpWsfo1Yx6wSBOMKWFABwTV+mwDCE1Vaau36nKTt8fSNQMzaQLpIActRslEMQtDiv1syQXM0t5CFRbo0OCUf27gaAr2fmKb8Wqkr1gDzLPVWDlCENdh3cii9sL4JjyMPaq7+4OqaD02QLjeAMoEyEjKno22AANCcRtndS3nIrx+hd1aK80ND0yu0YLZbpwUUBbBRHdyScJdYcfEe5QeYjO4EXFpTsb1gOHxLb9cbsHX62IVo/O7xxipV5sEImAZGSj0d8sawpqo6QmSHEzXuY4dfRp6UNcQYJICal7WI9T7BVO5BWPmQR+chHJC0VNjRPxV+5HlEWYK4n0J+PQyTdE1+DyBqd+6oM8AnoH2Yp8ScG+eM61CAgboodUM//X6S3pof3lX8GqDT9t5TYWE8WftZE2A3t88GiDzYqaN3pkOC8u6P65KqwSIQYw0lLKsGW/2hpz/ySDW8M12/xuWvkZhnVYTQA3lL5+Vwa3FncN/lUEdu5HI6BxlRbW5x9U+N+acSs72jPC1hFPW0e6Lo/PPlu0UAXfdQ8RIDZNV9VJbMg4BFpjwgINzgNBzXu7+7iOjIsyi38lDjWzTiylN3dSDbgGgBh9wtHxaqrWj2ibQOL1i3uJzDjRK5vq/6iVf66LdMVb/IqcD1EWiPDNls+Cengm5lH5vKjGLxU";
// const engineLocation = "https://cdn.jsdelivr.net/npm/scandit-sdk@4.x/build";
const engineLocation = `${process.env.BASE_URL}/scandit`;

Vue.prototype.$scandit = ScanditSDK;
Vue.prototype.$scandit.configure(licenseKey, {
    engineLocation: engineLocation,
    preloadEngineLibrary: true,
    preloadCameras: true
});

// Vue Offline
import VueOffline from 'vue-offline';
Vue.use(VueOffline);

// Vue Toasted
import VueToasted from 'vue-toasted';
Vue.use(VueToasted, {
  iconPack : 'custom-class' // set your iconPack, defaults to material. material|fontawesome|custom-class
});

// Vue Scrollto
let VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease-in",
    offset: -20,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

// Vue Signature Pad
import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

// Firebase
let firebase = require('firebase/app');
firebase.firestore().enablePersistence().then();

import './registerServiceWorker'
import '@/styles/imports.scss';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
